import {cloneDeep, get} from 'lodash';
import {getBool, getString} from 'Core/helpers/data';
import {TherapistsListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {TherapistsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);
	
	result = new TherapistsListItemDataObject(
		getString(result, 'uniqueID'),
		getString(result, 'firstName'),
		getString(result, 'lastName'),
		getString(result, 'telephone'),
		getString(result, 'mobilePhone'),
		getString(result, 'email'),
		getString(result, 'address'),
		getString(result, 'backgroundCalendarColor'),
		getString(result, 'fontCalendarColor'),
		(typeof get(result, 'active') !== 'boolean' && !!get(result, 'active') ? true : getBool(result, 'active'))
	);

	return result;
}

// @note There is no output function since list is read only.